import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import useAdminStyles from './adminStyles';

/**
 * Loading / error / forbidden placeholder that keeps the page chrome in place.
 */
const StateCard = ({ isLoading, isForbidden, isError, children }) => {
    const classes = useAdminStyles();
    if (isLoading) {
        return (
            <div className={classes.stateCard} style={{ display: 'flex', justifyContent: 'center', minHeight: '160px' }}>
                <CircularProgress />
            </div>
        );
    }
    if (isForbidden) {
        return (
            <div className={`${classes.stateCard} ${classes.stateCardWarn}`}>
                You do not have access to this section. The admin page is restricted to a fixed list of accounts.
            </div>
        );
    }
    if (isError) {
        return (
            <div className={`${classes.stateCard} ${classes.stateCardWarn}`}>
                Something went wrong while loading this section. Check the server logs and try again.
            </div>
        );
    }
    return children || null;
};

export default StateCard;
